import { Controller } from "@hotwired/stimulus"

export default class DealBulkActionsController extends Controller {
  static targets = ["count", "action"]

  selectionChanged({ detail: { selectedIds } }) {
    this.element.classList.toggle("hidden", selectedIds.length === 0)
    this.countTarget.textContent = selectedIds.length

    this.actionTargets.forEach((link) => {
      const url = new URL(link.href)
      url.search = new URLSearchParams(selectedIds.map((id) => ["ids[]", id]))
      link.href = url
    })
  }
}
